import React, { useEffect, useState } from "react";
import { Loader2, AlertTriangle } from "lucide-react";
import { csuiteApi } from "../../../lib/csuiteApi";

const RAG_CLR = { Green: "#16A34A", Amber: "#D97706", Red: "#DC2626" };
const DIMS = ["revenue", "margin", "delivery", "people", "risk"];

/** Executive Scorecard — one row per business unit, RAG dots across 5 dims. */
export default function Scorecard() {
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { csuiteApi.scorecard().then(setD).catch(e => setErr(e.message)); }, []);
  if (err) return <div className="p-6 text-red-700 flex items-center gap-2"><AlertTriangle size={16}/>{err}</div>;
  if (!d) return <div className="p-10 grid place-items-center"><Loader2 className="animate-spin text-sky-700"/></div>;

  return (
    <div data-testid="platinum-scorecard">
      <div className="mb-4">
        <div className="font-mono text-[10px] uppercase tracking-widest text-zinc-500">Executive Scorecard</div>
        <h2 className="font-display text-2xl font-extrabold tracking-tight">Business-Unit RAG</h2>
        <div className="text-sm text-zinc-500 mt-1">Refreshed {new Date(d.asOf).toLocaleString()}. Score = weighted RAG across 5 dimensions.</div>
      </div>

      <div className="card p-0 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-zinc-50 border-b border-[var(--border)]">
            <tr>
              <th className="text-left px-4 py-2 font-mono text-[10px] uppercase text-zinc-500">Business Unit</th>
              {DIMS.map(d => <th key={d} className="text-center px-4 py-2 font-mono text-[10px] uppercase text-zinc-500">{d}</th>)}
              <th className="text-right px-4 py-2 font-mono text-[10px] uppercase text-zinc-500">Score</th>
            </tr>
          </thead>
          <tbody>
            {d.units.map((u, i) => (
              <tr key={u.bu} className="border-b border-[var(--border)] last:border-0" data-testid={`scorecard-row-${i}`}>
                <td className="px-4 py-3 font-medium">{u.bu}</td>
                {DIMS.map(k => (
                  <td key={k} className="text-center px-4 py-3">
                    <span className="inline-block w-4 h-4 rounded-full" style={{ background: RAG_CLR[u[k]] || "#71717A" }} title={u[k]} />
                  </td>
                ))}
                <td className="text-right px-4 py-3 font-mono">
                  <span className={`font-display text-lg font-extrabold ${u.score >= 90 ? "text-emerald-700" : u.score >= 75 ? "text-sky-700" : "text-amber-700"}`}>
                    {u.score}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="mt-3 flex items-center gap-4 font-mono text-[10px] uppercase text-zinc-500">
        <span className="flex items-center gap-1"><span className="inline-block w-2.5 h-2.5 rounded-full" style={{background: RAG_CLR.Green}}/>Green</span>
        <span className="flex items-center gap-1"><span className="inline-block w-2.5 h-2.5 rounded-full" style={{background: RAG_CLR.Amber}}/>Amber</span>
        <span className="flex items-center gap-1"><span className="inline-block w-2.5 h-2.5 rounded-full" style={{background: RAG_CLR.Red}}/>Red</span>
      </div>
    </div>
  );
}
